import React from "react";

const PenToolIcon = ({ ...rest }) => (
  <svg
    {...rest}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_38_1327)">
      <path
        d="M23.7939 6.17217L17.8277 0.205946C17.5532 -0.0686487 17.1079 -0.0686487 16.8334 0.205946L13.7565 3.28283C13.4819 3.55743 13.4819 4.0026 13.7565 4.2772L14.0611 4.58179L6.01353 8.60556C5.8595 8.68257 5.73907 8.81345 5.67514 8.97334L0.0525508 23.0297C0.0517071 23.0317 0.0509102 23.0337 0.0501133 23.0358C0.0428945 23.0538 0.0366601 23.072 0.0310351 23.0904C0.0188476 23.1301 0.00923816 23.1762 0.00441002 23.2202C-0.0162619 23.4092 0.0391445 23.5897 0.150332 23.731C0.154457 23.7362 0.158536 23.7415 0.162848 23.7467C0.332114 23.9498 0.591944 24.0342 0.835554 23.9874C0.853554 23.984 0.87132 23.9794 0.889085 23.9745C0.892789 23.9735 0.896585 23.9729 0.900289 23.9718C0.924007 23.9649 0.947398 23.9567 0.970414 23.9472L15.0266 18.3248C15.1865 18.2608 15.3174 18.1404 15.3944 17.9864L19.4182 9.93883L19.7228 10.2434C19.8601 10.3807 20.04 10.4494 20.2199 10.4494C20.3998 10.4494 20.5799 10.3808 20.7171 10.2434L23.794 7.16654C24.0685 6.89199 24.0685 6.44681 23.7939 6.17217ZM14.2562 17.1184L3.62233 21.3719L9.63782 15.3564C9.91322 15.4885 10.2215 15.5626 10.5467 15.5626C11.7098 15.5626 12.6561 14.6163 12.6561 13.4532C12.6561 12.2901 11.7098 11.3438 10.5467 11.3438C9.38357 11.3438 8.4373 12.2901 8.4373 13.4532C8.4373 13.7784 8.51141 14.0867 8.64346 14.3621L2.62797 20.3776L6.88147 9.74373L15.1092 5.62992L18.37 8.8907L14.2562 17.1184ZM9.84356 13.4532C9.84356 13.0655 10.159 12.7501 10.5467 12.7501C10.9344 12.7501 11.2498 13.0655 11.2498 13.4532C11.2498 13.8409 10.9344 14.1563 10.5467 14.1563C10.159 14.1563 9.84356 13.8409 9.84356 13.4532ZM20.2199 8.75185L19.7137 8.24565C19.7133 8.24523 19.7128 8.24481 19.7124 8.24438L15.7556 4.28751C15.755 4.28699 15.7545 4.28648 15.754 4.28596L15.248 3.78004L17.3305 1.69756L22.3024 6.66943L20.2199 8.75185Z"
        fill="#D33479"
      />
    </g>
    <defs>
      <clipPath id="clip0_38_1327">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PenToolIcon;
